import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_spmjnz3e: FaireBrandEntity = {
  token: "b_spmjnz3e",
  type: "brand",
  name: "Lemon Lorraine's LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/b535b6f4a3d89e620390ef2c631d654ece66afef66b0f4fe39f6d8b12eb5cc64.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1dade3dabcb111401637e6a5e688b92b2701bde6d5f2dde99c9d07dd5699df86.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b535b6f4a3d89e620390ef2c631d654ece66afef66b0f4fe39f6d8b12eb5cc64.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1dade3dabcb111401637e6a5e688b92b2701bde6d5f2dde99c9d07dd5699df86.png",
  location: "Charleston, IL, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 620,
  isInsider: true,
  description:
    "Hello there! \n\nThank you so much for stopping to shop with us! We are Jeanette & Mallory and we co-own Lemon Lorraine’s together. \n\nIf you haven’t heard of us, we are a mother-in-Law / daughter-in-law duo working together every day to bring you quality graphic tees for every occasion. We are located in Charleston, IL (smack dab in the middle of corn field country).\n\nWhen we started our business in 2016 in our garage, we never dreamed we would one day be selling tees across the globe. Our mission is to design one-of-a-kind tees that allow you to bring your story to life one tee at a time. \n\nxoxo\nJeanette & Mallory ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:28.341Z",
    importedBy: "entity-db-cli",
  },
};
